export const ALL_COURSE_REQUEST = "@AllCourseReducer/ALL_COURSE_REQUEST";
export const ALL_COURSE_SUCCESS = "@AllCourseReducer/ALL_COURSE_SUCCESS";
export const ALL_COURSE_FAILED = "@AllCourseReducer/ALL_COURSE_FAILED";
